import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import Icon from "../components/Icon";
import "./AdPage.css";

const APP_STORE_URL = "https://apps.apple.com/us/app/pahincho/id6788609680";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.pahincho.pahincho";

const StoreQr: React.FC<{ value: string; label: string }> = ({
  value,
  label,
}) => (
  <QRCodeCanvas
    value={value}
    size={168}
    level="Q"
    marginSize={4}
    bgColor="#ffffff"
    fgColor="#1a1a1a"
    title={`${label} download QR`}
  />
);

const AdPage: React.FC = () => (
  <div className="ad-page">
    <div className="ad-page__glow ad-page__glow--one" aria-hidden="true" />
    <div className="ad-page__glow ad-page__glow--two" aria-hidden="true" />

    <main className="ad-page__stage">
      <header className="ad-page__brand">
        <Icon
          name="pahincho-logo-large"
          className="ad-page__logo"
          size={72}
        />
        <span className="ad-page__name-sr">Pahincho</span>
      </header>

      <p className="ad-page__question">
        Stuff sitting around that you barely use?
      </p>

      <p className="ad-page__support">
        Give it away — or let a neighbor borrow it.
      </p>

      <aside className="ad-page__scan">
        <p className="ad-page__scan-label">Scan to download the app</p>
        <div className="ad-page__qr-row">
          <a
            className="ad-page__qr-item"
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download on the App Store"
          >
            <div className="ad-page__qr">
              <StoreQr value={APP_STORE_URL} label="iOS" />
            </div>
            <span>iOS</span>
          </a>
          <a
            className="ad-page__qr-item"
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get it on Google Play"
          >
            <div className="ad-page__qr">
              <StoreQr value={PLAY_STORE_URL} label="Android" />
            </div>
            <span>Android</span>
          </a>
        </div>
      </aside>
    </main>
  </div>
);

export default AdPage;
